export const NavLogIcon = () => {
  return (
    <svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.75" y="0.75" width="23.5" height="28.5" rx="4.25" fill="white" />
      <rect
        x="0.75"
        y="0.75"
        width="23.5"
        height="28.5"
        rx="4.25"
        stroke="black"
        strokeWidth="1.5"
      />
      <line x1="6.5" y1="10.5" x2="18.5" y2="10.5" stroke="black" />
      <line x1="6.5" y1="14.5" x2="18.5" y2="14.5" stroke="black" />
      <line x1="6.5" y1="18.5" x2="18.5" y2="18.5" stroke="black" />
    </svg>
  );
};
